import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { ErrorHandler, Injectable, NgZone, inject } from '@angular/core';
import { ErrorLog } from '../../models/error-log';
import { environment } from '../../../environments/environment';
import { LoggerService } from '../logger.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    private zone = inject(NgZone);
    private http = inject(HttpClient);
    private logger = inject(LoggerService);

    private readonly _baseUrl = environment.baseUrl;

    handleError(error: any): void {
        // Every unhandled error must reach the logger (Issue #8): swallowing
        // non-ErrorLog errors hides change-detection failures that abort
        // ApplicationRef.tick() and leave parts of the UI un-rendered.
        this.logger.error('Unhandled application error', error);

        if (
            !(error instanceof HttpErrorResponse) &&
            error instanceof ErrorLog
        ) {
            this.zone.run(() =>
                this.http
                    .post(`${this._baseUrl}/api/v2/telemetry`, error)
                    .subscribe()
            );
        }
    }
}
